import React from 'react';
// import Resume from '../images/Abhishek Maurya.pdf';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';




const Portfolio = () => {

  const resumePath = '../images/Abhishek Maurya.pdf';
  const fileName = 'Abhishek Maurya.pdf';
  return (
    <div>
      <h1>Portfolio</h1>
      <Button>



        <Link
          to={resumePath}
          download={fileName}
          width="90vw"
          height="600"
        >
          <p>Alternative text - include a link to the PDF file here.</p>
        </Link>
      </Button>
    </div>
  );
}

export default Portfolio;